/* GA4 (gtag.js), Consent Mode v2 and CookieYes are injected via Netlify snippet
injection — they live in the Netlify UI, not this repo — so window.gtag may be
absent locally, in ad-blocked sessions, or if the snippet is ever removed.
Events are best-effort: never let analytics break the user flow. */
const trackEvent = (name, params = {}) => {
  if (typeof window === 'undefined' || typeof window.gtag !== 'function') return;
  window.gtag('event', name, params);
};

export default trackEvent;
